import React from 'react';

import { Cell, Container, Grid } from '@zeiss/ods-components-react';

import { Media, Text } from '../../../../components';
import {
  StyledContainer,
  StyledHeadline,
  StyledMainDescription,
} from '../../styled';

const Composer = ({
  title,
  description,
}: {
  description: string;
  title: string;
}) => {
  return (
    <StyledContainer>
      <Grid>
        <Container.FullBleed>
          <Cell.Basic colStarts={2} colSpan={6}>
            <Grid>
              <Container.FullBleed>
                <Cell.Basic colSpan={8}>
                  <StyledHeadline headline={title} />
                </Cell.Basic>
                <Cell.Basic colSpan={8}>
                  <StyledMainDescription size="l">
                    {description}
                  </StyledMainDescription>
                </Cell.Basic>
                <Cell.Basic colSpan={6}>
                  <Text size="m">
                    He has created artistic collaborations with partners such as
                    Ensemble Modern, Frankfurt; IRCAM; Google; The Guggenheim;
                    The Alvin Ailey Dance Company; Enjoy Jazz Festival; The
                    Future en Seine Festival; The Matadero; The Jewish Culture
                    Festival, Krakow, The Jewish Museum, Berlin; The Pacific
                    North Western Ballet; The ZKM and ZEISS amongst others.
                  </Text>
                </Cell.Basic>
                <Cell.Basic colSpan={6}>
                  <Grid>
                    <Container.FullBleed>
                      <Cell.Basic colSpan={12}>
                        <Text size="m">
                          He has performed as violist with the Orpheus Chamber
                          Orchestra in NYC, The Berlin Staatskapelle, Ensemble
                          Intercontemporain amongst others. He has recorded for
                          Deutsche Grammophon under Pierre Boulez with Ensemble
                          Intercontemporain.
                        </Text>
                      </Cell.Basic>
                      <Cell.Basic colSpan={12}>
                        <Text size="m">
                          He is a consultant and lecturer on such topics as
                          transformation processes in the arts and strategic
                          business development in the arts in the 21st century.
                        </Text>
                      </Cell.Basic>
                    </Container.FullBleed>
                  </Grid>
                </Cell.Basic>
              </Container.FullBleed>
            </Grid>
          </Cell.Basic>
          <Cell.Basic colStarts={9} colSpan={3}>
            <Media imgUrl="./images/info-pages/info-portrait-emmanuel-witzthum.jpg" />
          </Cell.Basic>
        </Container.FullBleed>
      </Grid>
    </StyledContainer>
  );
};

export default Composer;
